import { FEATURE_KEYS, parseEnabledFeatures } from '@echo-work-platform/shared-types';

export const KNOWLEDGE_BASE = 'knowledge-base';
export const DESKTOP_DOWNLOADS = 'desktop-downloads';

// Read at RENDER time only: initAuth() fills this after module evaluation (the EW-92 trap).
let featureStates: Record<string, boolean> = parseEnabledFeatures(undefined);

export function applyRuntimeFeatures(raw: string | null | undefined): void {
  featureStates = parseEnabledFeatures(raw, (unknown) => {
    console.warn(
      `enabledFeatures names ${unknown.length} unknown feature(s): ${unknown.join(', ')}. Known keys: ${FEATURE_KEYS.join(', ')}.`,
    );
  });
}

export const isFeatureEnabled = (key: string): boolean => featureStates[key] === true;
